export default __webpack_public_path__ + "static/media/page-title-aboutus-ru.cfedf01e.svg";